import { gql } from '@apollo/client';
import PRODUCT_VARIANT from 'api/fragments/PRODUCT_VARIANT';
const GET_PRODUCT_VARIANTS = gql `
  ${PRODUCT_VARIANT}
  query GetProductVariants(
    $first: Int
    $after: String
    $productId: ID!
    $status: String
    $productVariantColors: [ID] = []
  ) {
    node(id: $productId) {
      ... on ProductNode {
        id
        variants(first: $first, after: $after, status: $status, colorId: $productVariantColors) {
          edges {
            node {
              ...ProductVariantFragment
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_VARIANTS;
